<div class="question question-hurt">
    <h2>{{ question.title }}</h2>
    <h3>{{ question.help }}</h3>

    <app-feedback-hurt-answer
      [previousAnswers]="previousAnswers"
      [answeredAnswers]="answeredAnswers"
      [feedback]="feedback"
      [question]="question"
      [hasAnsweredQuestion]="hasAnsweredQuestion"
      (onAnswerChange)="answerChanged($event)"
      (onNextQuestionClicked)="onNextQuestionClicked($event)">
    </app-feedback-hurt-answer>
</div>

<!--
<div class="back" *ngIf="hasAnsweredQuestion">
    <button mat-icon-button color="primary" (click)="onPreviousQuestionClicked(question)">
        <mat-icon>arrow_back</mat-icon>
    </button>
</div>
-->
